<template>
  <div class="sub-title">
    <div class="title">{{ title }}</div>
    <div class="subfix-line"></div>
  </div>
</template>

<script setup>
defineProps({
  title: {
    type: String,
    default: ''
  }
})
</script>

<style lang="scss" scoped>
.sub-title {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  .title {
    font-family: PingFang SC;
    font-size: 13px;
    font-weight: 600;
    line-height: 18px;
    letter-spacing: 0em;
    color: #323233;
    margin-right: 8px;
  }
  .subfix-line {
    flex: 1;
    height: 1px;
    box-sizing: border-box;
    border-top: 1px dashed #f5e8ff;
  }
}
</style>
